import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuex from 'vuex';
import VueProgressiveImage from 'vue-progressive-image'
import i18n from './i18n'
import * as VueGoogleMaps from 'vue2-google-maps'
import lang from './utils/lang'
import Constants from './constants'
import VueGtag from 'vue-gtag'
import VueLazyload from 'vue-lazyload'

import store from './store'
import mixin from './mixin'

import '@/assets/tailwind.scss'

Vue.use(Vuex)
Vue.use(mixin)
Vue.use(VueProgressiveImage)
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyChXQpXurpGspZpX7oLjEnKXNCJWSZ6NjI",
    libraries: 'places',
    region: 'JP',
    language: lang
  }
})
Vue.use(
  VueGtag,
  {
    config: { id: 'G-QY1DMKTBRM' }
  },
  router
)
const loadimage = require('./assets/images/loading.gif')
const errorimage = require('./assets/images/no-image.jpg')
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: errorimage,
  loading: loadimage,
  attempt: 1
})

Vue.config.productionTip = false

// NOTE: リンクで直接マップにアクセスする際にtokenが渡された場合はセットする
// TODO: App.vueに移動した方がよさそう
router.beforeEach((to, from, next) => {
  const token = to.query && to.query.token
  const appId = store.getters['user/getAppId']
  if (token) {
    if (store.getters['user/getToken'] === null) {
      store.dispatch('resetAll')
    }
    store.dispatch('user/setToken', token)
  } else if (appId !== null && appId !== Constants.API_ID) {
    store.dispatch('resetAll')
  } else {
    if (store.getters['user/getToken'] !== null) {
      store.dispatch('resetAll')
    } else {
      store.dispatch('user/resetToken')
    }
  }
  store.dispatch('user/setAppId')
  next()
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created: () => (document.documentElement.setAttribute('lang', lang)),
}).$mount("#app")
